import { Grid, TextField } from "@material-ui/core";
import { forwardRef, useImperativeHandle } from "react";
import { useForm, Controller } from "react-hook-form";

const PasswordForm = forwardRef((props, ref) => {
  const { onSubmitForm, defaultValues, loading = false } = props;

  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues ?? null,
  });

  useImperativeHandle(ref, () => ({
    submit: () => handleSubmit(onSubmitForm)(),
  }));

  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid container direction='row' spacing={1}>
        <Grid item xs={12}>
          <Controller
            name='password'
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <TextField
                {...field}
                label='رمز عبور'
                size='small'
                margin='dense'
                type='password'
                variant='outlined'
                disabled={loading}
                error={errors.password}
                helperText={errors.password && "فیلد نمیتواند خالی باشد"}
                fullWidth
              />
            )}
          />
        </Grid>
        <Grid item xs={12}>
          <Controller
            name='password_confirmation'
            control={control}
            rules={{
              required: true,
              validate: (val) => {
                if (watch("password") !== val) return false;
              },
            }}
            render={({ field }) => (
              <TextField
                {...field}
                label='تکرار رمز عبور'
                size='small'
                margin='dense'
                type='password'
                disabled={loading}
                variant='outlined'
                error={errors?.password_confirmation}
                helperText={
                  errors?.password_confirmation && errors?.password_confirmation?.type === "required"
                    ? "فیلد نمیتواند خالی باشد"
                    : errors?.password_confirmation?.type === "validate" && "رمز عبور با تکرارش همخوانی ندارد!"
                }
                fullWidth
              />
            )}
          />
        </Grid>
      </Grid>
    </form>
  );
});

export default PasswordForm;
